// extracted by mini-css-extract-plugin
export default {"ReportComponentsHeaderButtons":"component-header-buttons_ReportComponentsHeaderButtons__x+mol","ReportControlButtons":"component-header-buttons_ReportControlButtons__SNvQ3"};